/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file StringResource component
 * @author Dustin Gage
 */

import React, { memo, ReactElement, useMemo } from "react";
import { getString } from "../api/get-string";

interface IProps {
	token?: StringResourceId;
	raw?: string;
	isHtml?: boolean;
}

export const StringResource = memo(function StringResource(props: IProps): ReactElement {
	const { token, raw, isHtml = false } = props;

	const stringResource = useMemo(() => {
		return raw ? raw : token ? getString(token) : "";
	}, [token, raw]);

	return (
		<>{isHtml ? <span dangerouslySetInnerHTML={{ __html: stringResource }} /> : <>{stringResource}</>}</>
	);
});
